const relationship = [
  { label: 'Ehepartner', value: 'SPOUSE' },
  { label: 'Lebenspartner', value: 'PARTNER' },
  { label: 'anderes Verhältnis', value: 'OTHER' }
]

export default relationship
